module.exports = __webpack_public_path__ + "img/c04_unitstartechtakabarachampion_Normal_ua.c8c75bbf.webp";